interface UpdateItem {
  time: string;
  tag: string;
  title: string;
  summary: string;
}

const updates: UpdateItem[] = [
  {
    time: '10分钟前',
    tag: '独家猛料',
    title: '某顶流艺人私下言论录音曝光，人设面临崩塌危机',
    summary: '一段据称来自私人聚会场合的录音在社交平台疯传，涉及多位圈内人士。目前相关方尚未作出正式回应，事件持续发酵中。',
  },
  {
    time: '28分钟前',
    tag: '网曝门事件',
    title: '知名网红直播间翻车现场：不当言论引发全网抵制',
    summary: '一场直播中主播的即兴发言被录屏传播，大量网友表示强烈不满。多个品牌已紧急下架与该网红的合作内容。',
  },
  {
    time: '1小时前',
    tag: '今日黑料',
    title: '热门综艺录制现场冲突视频流出，节目组紧急公关',
    summary: '一段疑似嘉宾与节目组工作人员争执的画面被现场观众拍摄上传，相关话题迅速登上热搜，节目组已发布致歉声明。',
  },
  {
    time: '2小时前',
    tag: '吃瓜爆料',
    title: '影视圈某大导新片选角内幕曝光，潜规则引发行业震动',
    summary: '匿名业内人士向本平台投稿，详细披露了近期某备受关注的大制作电影选角过程中的不为人知的操作手法。',
  },
  {
    time: '3小时前',
    tag: '最新内幕',
    title: '社交平台内部员工泄露：某话题被刻意限流降热搜',
    summary: '有自称某平台员工的网友爆料，近期一个涉及知名企业的负面话题遭到了后台人工干预，相关数据截图已流出。',
  },
  {
    time: '5小时前',
    tag: '独家猛料',
    title: '某女星与前经纪公司解约大战升级，千万违约金成焦点',
    summary: '双方各执一词，围绕合同条款、资源分配等问题展开激烈交锋。业内人士分析此案将成为娱乐圈合约纠纷的标志性事件。',
  },
  {
    time: '7小时前',
    tag: '吃瓜爆料',
    title: '电竞圈知名选手私下聚会照片曝光，涉及多位公众人物',
    summary: '一组在某高端私人会所拍摄的照片在粉丝群中流传，画面中的人物关系引发网友热烈讨论和猜测。',
  },
  {
    time: '9小时前',
    tag: '网曝门事件',
    title: '某餐饮连锁品牌后厨卫生问题遭内部员工实名举报',
    summary: '举报人提供了大量现场照片和视频资料，展示出令人担忧的卫生状况。市场监管部门已介入调查，多家门店暂停营业。',
  },
];

const tagColors: Record<string, string> = {
  '独家猛料': 'bg-primary-100 text-primary-700',
  '网曝门事件': 'bg-accent-100 text-accent-800',
  '今日黑料': 'bg-foreground-100 text-foreground-700',
  '吃瓜爆料': 'bg-secondary-100 text-secondary-700',
  '最新内幕': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  const getTimeIcon = (time: string) => {
    if (time.includes('分钟')) return 'ri-timer-line text-primary-500';
    if (time.includes('小时') && parseInt(time) <= 2) return 'ri-fire-fill text-accent-500';
    return 'ri-time-line text-foreground-400';
  };

  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            实时快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            最新爆料动态，实时滚动更新
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-5 md:left-6 top-2 bottom-2 w-0.5 bg-background-300"></div>

          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pl-12 md:pl-14">
                {/* Timeline dot */}
                <div className={`absolute left-3.5 md:left-4.5 top-1 w-3 h-3 rounded-full border-2 border-background-50 ${idx === 0 ? 'bg-primary-500' : 'bg-background-300'}`}></div>

                <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                      {item.tag}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                      <i className={getTimeIcon(item.time)}></i>
                      {item.time}
                    </span>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}